import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomeService } from '../../services/home.service';
import { StoresService } from '../../services/stores.service';
import { CabinetService } from '../../services/cabinet.service';
import { timestampFormat } from '../../../../app/config/moment';
import { DesktopDevicesModalComponent } from '../desktop-devices/desktop-devices-modal/desktop-devices-modal.component';
import { CabinetComponent } from '../../cabinet/cabinet.component';
import { DesktopDevicesComponent } from '../desktop-devices/desktop-devices.component';

@Component({
  selector: 'app-handheld-devices',
  standalone: true,
  imports: [CommonModule, FormsModule, CabinetComponent, DesktopDevicesComponent],
  templateUrl: './handheld-devices.component.html',
  styleUrls: ['./handheld-devices.component.scss', '../../../app.component.scss']
}) 
export class HandheldDevicesComponent {

  activeTab: string = 'handheld';

  public timestampFormat = timestampFormat;
  public currentStoreId: string = '';
  public stockDetails: any = [];
  public isStore = false;
  public deviceType: string = "desktop";
  public totalCabinets: number = 0;
  public totalPages: number = 0;
  public currentPage: number = 1;
  public isSearch = false;
  public isFilter = false;
  public storeId: string = '';
  public deviceName: string = '';

  public isFilterResult = true;
  public isCabinets = true;
  public storeName: string = '';
  public deviceId: any;

  public desktoplist: any = [];
  public storeDetails: any;
  public totalDesktopCount: number = 0;

  public orderBy:string = "asc";

  public descValue: string;
  public stockReadValue: string;
  public search: string;
  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public selectedStatus = [];

  constructor(
    private router: Router,
    private spinnerService: NgxSpinnerService,
    public location: Location,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public cabinetService: CabinetService,
    public storeService: StoresService,
    public homeService: HomeService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.storeId = params['id'];
      if (this.storeId) {
        this.getStockDetails(this.storeId);
        this.getStoreName(this.storeId);
        this.getHandheldDevice(this.storeId, this.descValue, this.stockReadValue);
      } else {
        console.error('No stock ID provided in query parameters');
      }
    });
  }

  @NgModule({
    imports: [
      MatDialogModule,
    ],
  })

  goBack(){
    this.location.back(); 
  }
  
  getStockDetails(storeId: string) {
    this.homeService.getStockDetails(storeId).subscribe((res: any) => {
      if (res.success && res.data) {
        this.stockDetails = res.data;
      }
      console.log("res", res);
    });
  }

  onFilterChange(){
    this.getHandheldDevice(this.storeId, this.descValue, this.stockReadValue)
  }

  getHandheldDevice(storeId: string, descValue: string = "", search: string = "", stockReadValue: string = "") {
    this.homeService.getHandheldDevice(storeId, descValue, search, stockReadValue).subscribe((res: any) => {
      if (res.data) {
        this.desktoplist = res.data.data;
        this.totalDesktopCount = this.desktoplist.length;
      }
    });
  }

  onSearchSubmit() { 
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getHandheldDevice(this.storeId, this.descValue, this.stockReadValue,this.encodedSearchInput);
    }
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getHandheldDevice(this.storeId, this.descValue, this.stockReadValue);
    }
  }

  raisedAtSort(){
    this.isFilter = true;

    if (this.descValue === "asc") {
      this.descValue = "desc";
    }else{
      this.descValue = this.orderBy;
    }

    this.onFilterChange();
  }

  stockSort(){
    this.isFilter = true;

    if (this.stockReadValue === "asc") {
      this.stockReadValue = "desc";
    }else{
      this.stockReadValue = this.orderBy;
    }

    this.onFilterChange();
  }
  
  getDesktopSummary(storeId: string, devicesId: string, stockValue: string = " "){
    this.homeService.getDesktopSummary(storeId, devicesId, stockValue).subscribe((res: any) => {
      if (res.data) {
        this.desktoplist = res.data.data;
        this.totalDesktopCount = this.desktoplist.length;
      }
    })
  }

  getStoreName(storeId: string): void {
    this.homeService.getStoreName(storeId).subscribe(
      (response: any) => {
        this.storeName = response.data.name;
      },
      (error) => {
        console.error('Error fetching store name:', error);
      }
    );
  }

  resetSearch(): void {
    this.deviceName = '';
    this.getHandheldDevice(this.storeId, this.descValue, this.stockReadValue);
  } 

  searchByDesktopName(): void {
    this.desktoplist = this.desktoplist.filter((desktop: any) =>
      desktop.name.toLowerCase().includes(this.desktoplist.toLowerCase())
    );
  }

  navigateToDetailPage(deviceId: any, u_name: any, last_updated_at: any) {
    this.router.navigate([`/home/stores/${this.storeId}/devices/${deviceId}`], {
      queryParams: { u_name, last_updated_at }
    });
  }

  openPopup(event: MouseEvent) {
    let openedPopup = document.getElementsByClassName("dots-popup");
    let targetedElement = (event.target as HTMLElement).closest('td');
    let popupDiv = targetedElement.querySelector(".dots-popup") as HTMLElement;

    Array.from(openedPopup).forEach((el) => {
      if (el !== popupDiv) {
        el.classList.remove('active');
      }
    });

    popupDiv.classList.toggle("active");
    event.stopPropagation();

    document.addEventListener('click', function(event: any) {
      if (popupDiv.classList.contains("active") && !popupDiv.contains(event.target)) {
        popupDiv.classList.remove("active");
      }
    }, { once: true });
  }

  openDialog(desktopName: string, type: string, desktopId: string): void {
    const dialogRef = this.dialog.open(DesktopDevicesModalComponent, {
      data: {
        name: desktopName,
        type: type,
        device_id: desktopId, 
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getHandheldDevice(this.storeId);
      }
    });
  }


  
  

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    let route: string;
    switch (tab) {
      case 'cabinets':
        route = `/home/stores/${this.storeId}/cabinets`;
        break;
      case 'desktop':
        route = `/home/stores/${this.storeId}/devices`;
        break;
      case 'handheld':
        route = `/home/stores/${this.storeId}/handheld`;
        break;
      default:
        // route = `/home/stores/${this.storeId}/cabinets`;
    }
    this.router.navigate([route]);
  }

}
